export default "__VITE_ASSET__GRxRcJAr__"